export type SupportedLocale = 'en' | 'sv';

export type TranslationKey =
  | 'about.built'
  | 'about.commit'
  | 'about.environment'
  | 'about.release'
  | 'about.version'
  | 'colorScheme.currentClickFor'
  | 'colorScheme.dark'
  | 'colorScheme.light'
  | 'colorScheme.select'
  | 'colorScheme.switchTo'
  | 'colorScheme.system'
  | 'error.contactAdmin'
  | 'error.landingPageNotFound'
  | 'error.landingPageNotFoundDescription'
  | 'error.landingPageRenderFailed'
  | 'error.pageRenderFailed'
  | 'error.somethingWentWrong'
  | 'error.unableToLoadContent'
  | 'fileArea.download'
  | 'iconPicker.dialogDescription'
  | 'iconPicker.dialogTitle'
  | 'iconPicker.noIconsFound'
  | 'iconPicker.searchClearButton'
  | 'iconPicker.searchFieldPlaceholder'
  | 'iconPicker.labelSelect'
  | 'imageCrop.cancel'
  | 'imageCrop.chooseImage'
  | 'imageCrop.confirm'
  | 'imageCrop.confirming'
  | 'imageCrop.cropError'
  | 'imageCrop.noFileChosen'
  | 'imageCrop.zoom'
  | 'image.loadFailed'
  | 'iconCrop.currentIconAlt'
  | 'iconCrop.drawerTitle'
  | 'iconCrop.mediaFallback'
  | 'iconCrop.remove'
  | 'iconCrop.replace'
  | 'iconCrop.uploadAndCrop'
  | 'iconCrop.uploadFailed'
  | 'iconCrop.uploadFailedStatus'
  | 'svgPreview.browseStudio'
  | 'fileArea.noFiles'
  | 'fileArea.previewNotAvailable'
  | 'fileArea.search'
  | 'fileArea.sort'
  | 'fileArea.sortDateNewest'
  | 'fileArea.sortDateOldest'
  | 'fileArea.sortNameAsc'
  | 'fileArea.sortNameDesc'
  | 'fileArea.sortSizeLargest'
  | 'fileArea.sortSizeSmallest'
  | 'fileArea.typeAudio'
  | 'fileArea.typeDocument'
  | 'fileArea.typeImage'
  | 'fileArea.typeOther'
  | 'fileArea.typePdf'
  | 'fileArea.typePresentation'
  | 'fileArea.typeSpreadsheet'
  | 'fileArea.typeVideo'
  | 'fileArea.viewGrid'
  | 'fileArea.viewList'
  | 'form.submitSuccess'
  | 'form.submitFailed'
  | 'form.submitFailedDescription'
  | 'humanCheck.unavailable'
  | 'gallery.accepts'
  | 'gallery.allBlocks'
  | 'gallery.band'
  | 'gallery.band.gradient'
  | 'gallery.band.none'
  | 'gallery.band.strong'
  | 'gallery.band.subtle'
  | 'gallery.close'
  | 'gallery.conditional'
  | 'gallery.availableIn'
  | 'gallery.fieldsNote'
  | 'gallery.nameInAdmin'
  | 'gallery.live'
  | 'gallery.liveNote'
  | 'gallery.localized'
  | 'gallery.example'
  | 'gallery.fields'
  | 'gallery.next'
  | 'gallery.notOffered'
  | 'gallery.ownBuild'
  | 'gallery.previous'
  | 'gallery.required'
  | 'gallery.expand'
  | 'gallery.whenToUse'
  | 'gallery.contentBlocks'
  | 'gallery.documented'
  | 'gallery.pending'
  | 'gallery.pendingNote'
  | 'gallery.registered'
  | 'gallery.structural'
  | 'gallery.structuralNote'
  | 'gallery.undocumented'
  | 'navigation.close'
  | 'navigation.footer'
  | 'navigation.menu'
  | 'memberLogin.code'
  | 'memberLogin.codeFailed'
  | 'memberLogin.codeIntro'
  | 'memberLogin.codeSubmit'
  | 'memberLogin.email'
  | 'memberLogin.failed'
  | 'memberLogin.heading'
  | 'memberLogin.intro'
  | 'memberLogin.password'
  | 'memberLogin.setupRequired'
  | 'memberLogin.signOut'
  | 'memberLogin.submit'
  | 'memberLogin.tooManyAttempts'
  | 'navigation.primary'
  | 'navigation.title'
  | 'notFound.description'
  | 'notFound.goHome'
  | 'notFound.title'
  | 'posts.readMore'
  | 'signup.title'
  | 'signup.intro'
  | 'signup.closed'
  | 'signup.code'
  | 'signup.name'
  | 'signup.email'
  | 'signup.password'
  | 'signup.passwordHint'
  | 'signup.siteName'
  | 'signup.submit'
  | 'signup.submitting'
  | 'signup.successTitle'
  | 'signup.successBody'
  | 'signup.resend.title'
  | 'signup.resend.intro'
  | 'signup.resend.submit'
  | 'signup.resend.submitting'
  | 'signup.resend.done'
  | 'signup.resend.link'
  | 'signup.resend.formPrompt'
  | 'signup.resend.formLink'
  | 'signup.backToLogin'
  | 'signup.section.invite'
  | 'signup.section.you'
  | 'signup.section.site'
  | 'signup.section.inviteHelp'
  | 'signup.section.youHelp'
  | 'signup.section.siteHelp'
  | 'signup.verify.confirmTitle'
  | 'signup.verify.confirmBody'
  | 'signup.verify.confirm'
  | 'signup.verify.verifiedTitle'
  | 'signup.verify.verifiedBody'
  | 'signup.verify.signIn'
  | 'signup.verify.invalidTitle'
  | 'signup.verify.invalidBody'
  | 'signup.verify.newLink'
  | 'language.label'
  | 'signup.inviteCodeHelp'
  | 'signup.addressPreview'
  | 'signup.availability.checking'
  | 'signup.availability.available'
  | 'signup.error.invalid'
  | 'signup.error.password'
  | 'signup.error.password-breached'
  | 'signup.error.deployment'
  | 'signup.error.code'
  | 'signup.error.closed'
  | 'signup.error.throttled'
  | 'signup.error.email-taken'
  | 'signup.error.deployment-taken'
  | 'signup.error.name-taken'
  | 'signup.error.failed'
  | 'signup.issue.empty'
  | 'signup.issue.characters'
  | 'signup.issue.hyphens'
  | 'signup.issue.reserved'
  | 'signup.issue.too-long'
  | 'siteGate.heading'
  | 'siteGate.intro'
  | 'siteGate.password'
  | 'siteGate.submit'
  | 'siteGate.tooManyAttempts'
  | 'siteGate.wrongPassword'
  | 'social.clickToCopy'
  | 'social.copied'
  | 'social.copyFailed'
  | 'theme.select'
  | 'tours.addToCalendar'
  | 'tours.backToTours'
  | 'tours.bookBefore'
  | 'tours.datesToBeConfirmed'
  | 'tours.badgeFull'
  | 'tours.badgeQueue'
  | 'tours.bookingLede'
  | 'tours.bookTour'
  | 'tours.day'
  | 'tours.departure'
  | 'tours.duration'
  | 'tours.included'
  | 'tours.itinerary'
  | 'tours.notIncluded'
  | 'tours.perPerson'
  | 'tours.price'
  | 'tours.interestLede'
  | 'tours.print'
  | 'tourSignupEmail.bookedBody'
  | 'tourSignupEmail.departureLabel'
  | 'tourSignupEmail.detailsHeading'
  | 'tourSignupEmail.greeting'
  | 'tourSignupEmail.notificationBody'
  | 'tourSignupEmail.notificationHeading'
  | 'tourSignupEmail.peopleLabel'
  | 'tourSignupEmail.privacyLink'
  | 'tourSignupEmail.promotedBody'
  | 'tourSignupEmail.questions'
  | 'tourSignupEmail.firstInQueueLabel'
  | 'tourSignupEmail.openTour'
  | 'tourSignupEmail.seatsFreeLabel'
  | 'tourSignupEmail.seatsFreedAction'
  | 'tourSignupEmail.seatsFreedBody'
  | 'tourSignupEmail.subjectSeatsFreed'
  | 'tourSignupEmail.statusLabel'
  | 'tourSignupEmail.statusBooked'
  | 'tourSignupEmail.statusWaiting'
  | 'tourSignupEmail.subjectBooked'
  | 'tourSignupEmail.subjectNotification'
  | 'tourSignupEmail.subjectPromoted'
  | 'tourSignupEmail.subjectWaiting'
  | 'tourSignupEmail.termsLink'
  | 'tourSignupEmail.tourLabel'
  | 'tourSignupEmail.waitingBody'
  | 'forgotPasswordEmail.body'
  | 'forgotPasswordEmail.button'
  | 'forgotPasswordEmail.greeting'
  | 'forgotPasswordEmail.greetingNamed'
  | 'forgotPasswordEmail.ignore'
  | 'forgotPasswordEmail.subject'
  | 'statsAccountEmail.body'
  | 'statsAccountEmail.button'
  | 'statsAccountEmail.changePassword'
  | 'statsAccountEmail.heading'
  | 'statsAccountEmail.passwordLabel'
  | 'statsAccountEmail.subject'
  | 'statsAccountEmail.usernameLabel'
  | 'accountExists.subject'
  | 'accountExists.body'
  | 'accountExists.signIn'
  | 'accountExists.reset'
  | 'accountExists.ignore'
  | 'verifyEmail.afterConfirm'
  | 'verifyEmail.body'
  | 'verifyEmail.button'
  | 'verifyEmail.greeting'
  | 'verifyEmail.greetingNamed'
  | 'verifyEmail.ignore'
  | 'verifyEmail.subject'
  | 'signupNotice.body'
  | 'signupNotice.button'
  | 'signupNotice.deploymentLabel'
  | 'signupNotice.detailsHeading'
  | 'signupNotice.emailLabel'
  | 'signupNotice.nameLabel'
  | 'signupNotice.nextStep'
  | 'signupNotice.siteLabel'
  | 'signupNotice.subject'
  | 'signupNotice.workspaceLabel'
  | 'idleWorkspaceSummary.body'
  | 'idleWorkspaceSummary.button'
  | 'idleWorkspaceSummary.deleted'
  | 'idleWorkspaceSummary.detailsHeading'
  | 'idleWorkspaceSummary.provisioned'
  | 'idleWorkspaceSummary.subject'
  | 'idleWorkspaceSummary.unwarnedMailFailed'
  | 'idleWorkspaceSummary.unwarnedNoAdmin'
  | 'idleWorkspaceSummary.warned'
  | 'idleWorkspaceWarning.body'
  | 'idleWorkspaceWarning.button'
  | 'idleWorkspaceWarning.ignore'
  | 'idleWorkspaceWarning.subject'
  | 'tourSignup.acceptTerms'
  | 'tourSignup.acceptTermsRequired'
  | 'tourSignup.dataNotice'
  | 'tourSignup.dataNoticeRetention'
  | 'tourSignup.privacyLink'
  | 'tourSignup.termsLink'
  | 'tourSignup.email'
  | 'tourSignup.failed'
  | 'tourSignup.full'
  | 'tourSignup.queueOnly'
  | 'tourSignup.queueOnlyCount'
  | 'tourSignup.queueOnlyCountOne'
  | 'tourSignup.queueOnlyLede'
  | 'tourSignup.fullLede'
  | 'tourSignup.joinWaitingList'
  | 'tourSignup.name'
  | 'tourSignup.people'
  | 'tourSignup.peopleHelp'
  | 'tourSignup.phone'
  | 'tourSignup.phoneOptional'
  | 'tourSignup.required'
  | 'tourSignup.seatsLeft'
  | 'tourSignup.seatsLeftOne'
  | 'tourSignup.signupsClosed'
  | 'tourSignup.submit'
  | 'tourSignup.submitting'
  | 'tourSignup.successBooked'
  | 'tourSignup.successWaiting'
  | 'tourSignup.title'
  | 'tourSignup.tooManyPeople'
  | 'tours.registerInterest'
  | 'tours.signUpBefore'
  | 'tours.share'
  | 'tours.shareCopied'
  | 'tours.shareFailed'
  | 'tours.viewItinerary';

const translations: Record<SupportedLocale, Record<TranslationKey, string>> = {
  en: {
    'about.built': 'Built',
    'about.commit': 'Commit',
    'about.environment': 'Environment',
    'about.release': 'Release',
    'about.version': 'Version',
    'colorScheme.currentClickFor': 'Current: {{current}}, click for {{next}}',
    'colorScheme.dark': 'dark',
    'colorScheme.light': 'light',
    'colorScheme.select': 'Select appearance',
    'colorScheme.switchTo': 'Switch to {{colorScheme}} appearance',
    'colorScheme.system': 'system preference',
    'error.contactAdmin':
      'Please contact the administrator if the problem persists.',
    'error.landingPageNotFound': 'Landing page was not found',
    'error.landingPageNotFoundDescription':
      'Please create a page in the CMS and assign it to be a landing page.',
    'error.landingPageRenderFailed': 'The landing page could not be rendered.',
    'error.pageRenderFailed':
      "The page you're looking for could not be rendered.",
    'error.somethingWentWrong': 'Something went wrong!',
    'error.unableToLoadContent':
      'Unable to load application content. Please try again later.',
    'iconPicker.dialogDescription': 'Choose the best suited icon',
    'iconPicker.dialogTitle': 'Select an Icon',
    'iconPicker.noIconsFound': 'No icons found...',
    'iconPicker.searchClearButton': 'Clear search',
    'iconPicker.searchFieldPlaceholder': 'Search icon...',
    'iconPicker.labelSelect': 'Select icon',
    'imageCrop.cancel': 'Cancel',
    'imageCrop.chooseImage': 'Choose image',
    'imageCrop.confirm': 'Confirm',
    'imageCrop.confirming': 'Uploading…',
    'imageCrop.cropError': 'Failed to process the image. Please try again.',
    'imageCrop.noFileChosen': 'No file chosen',
    'imageCrop.zoom': 'Zoom',
    'image.loadFailed': 'Image failed to load.',
    'iconCrop.currentIconAlt': 'Current icon',
    'iconCrop.drawerTitle': 'Crop Icon (1:1)',
    'iconCrop.mediaFallback': 'Media #{{id}}',
    'iconCrop.remove': 'Remove',
    'iconCrop.replace': 'Replace',
    'iconCrop.uploadAndCrop': 'Upload & Crop',
    'iconCrop.uploadFailed': 'Upload failed',
    'iconCrop.uploadFailedStatus': 'Upload failed ({{status}}): {{message}}',
    'svgPreview.browseStudio': 'Browse Studio',
    'fileArea.download': 'Download',
    'fileArea.noFiles': 'No files',
    'fileArea.previewNotAvailable': 'Preview not available for this file type',
    'fileArea.search': 'Search...',
    'fileArea.sort': 'Sort',
    'fileArea.sortDateNewest': 'Newest first',
    'fileArea.sortDateOldest': 'Oldest first',
    'fileArea.sortNameAsc': 'Name (A-Z)',
    'fileArea.sortNameDesc': 'Name (Z-A)',
    'fileArea.sortSizeLargest': 'Size (largest)',
    'fileArea.sortSizeSmallest': 'Size (smallest)',
    'fileArea.typeAudio': 'Audio',
    'fileArea.typeDocument': 'Document',
    'fileArea.typeImage': 'Image',
    'fileArea.typeOther': 'Other',
    'fileArea.typePdf': 'PDF',
    'fileArea.typePresentation': 'Presentation',
    'fileArea.typeSpreadsheet': 'Spreadsheet',
    'fileArea.typeVideo': 'Video',
    'fileArea.viewGrid': 'Grid view',
    'fileArea.viewList': 'List view',
    'form.submitSuccess': 'Form submitted successfully',
    'form.submitFailed': 'Form submission failed',
    'form.submitFailedDescription': 'Please try again.',
    'humanCheck.unavailable':
      'The spam check could not load, so this form cannot be sent. A content blocker is the usual cause — allow challenges.cloudflare.com, or try another browser.',
    'gallery.accepts': 'Accepts',
    'gallery.allBlocks': 'All blocks',
    'gallery.band': 'Background',
    'gallery.band.gradient': 'Gradient',
    'gallery.band.none': 'None',
    'gallery.band.strong': 'Strong',
    'gallery.band.subtle': 'Subtle',
    'gallery.close': 'Close full screen',
    'gallery.conditional': 'Shown depending on another choice',
    'gallery.availableIn': 'Available in',
    'gallery.fieldsNote':
      'Generated from the block definition, so this table cannot drift from the fields the admin actually shows.',
    'gallery.nameInAdmin': 'Name in the admin',
    'gallery.live': 'Live',
    'gallery.liveNote':
      'Follows the theme above — no CSS was written for this page.',
    'gallery.example': 'Example',
    'gallery.fields': 'What an editor fills in',
    'gallery.next': 'Next block',
    'gallery.notOffered':
      'Editors cannot add this block to a page, but it still shows where it is already in use.',
    'gallery.ownBuild':
      'What this block shows is built by each workspace\u2019s own developers, so there is no example to draw here. See it where a page uses one.',
    'gallery.previous': 'Previous block',
    'gallery.required': 'required',
    'gallery.expand': 'Full screen',
    'gallery.localized': 'Translated per language',
    'gallery.whenToUse': 'When to reach for it',
    'gallery.contentBlocks': 'Content blocks',
    'gallery.documented': 'Documented',
    'gallery.pending': 'Not in the grid above',
    'gallery.pendingNote':
      'A block turns up here the day it is built — either nobody has written about it yet, or nothing offers it when a page is put together. This list is read from the code itself, so the gallery cannot quietly fall behind what the platform can do.',
    'gallery.registered': 'Registered',
    'gallery.structural': 'Structural',
    'gallery.structuralNote':
      'Listed for completeness, not a design choice an editor makes.',
    'gallery.undocumented': 'Nobody has written about this one yet.',
    'navigation.close': 'Close menu',
    'navigation.footer': 'Footer',
    'navigation.menu': 'Menu',
    'memberLogin.code': 'Code',
    'memberLogin.codeFailed':
      'That code did not work. Enter the current one from your authenticator app.',
    'memberLogin.codeIntro':
      'Enter the six-digit code from your authenticator app.',
    'memberLogin.codeSubmit': 'Continue',
    'memberLogin.email': 'Email',
    'memberLogin.failed': 'Check your email and password, then try again.',
    'memberLogin.heading': 'Sign in',
    'memberLogin.intro':
      'Sign in to read the parts of this site kept for members.',
    'memberLogin.password': 'Password',
    'memberLogin.setupRequired':
      'Your account needs an authenticator app. Set it up in the admin, then sign in here.',
    'memberLogin.signOut': 'Sign out',
    'memberLogin.submit': 'Sign in',
    'memberLogin.tooManyAttempts':
      'Too many attempts. Wait a moment, then try again.',
    'navigation.primary': 'Main',
    'navigation.title': 'Navigation',
    'notFound.description':
      'Sorry, we could not find the page you were looking for.',
    'notFound.goHome': 'Go back home',
    'notFound.title': 'Page not found',
    'posts.readMore': 'Read more',
    'signup.title': 'Create your site',
    'signup.intro': 'Fill in the details below to get your own site.',
    'signup.closed': 'Signup is not open right now. Please check back later.',
    'signup.code': 'Invite code',
    'signup.name': 'Your name',
    'signup.email': 'Email address',
    'signup.password': 'Password',
    'signup.passwordHint': 'At least 12 characters.',
    'signup.siteName': 'Site name',
    'signup.submit': 'Create site',
    'signup.submitting': 'Creating site...',
    'signup.successTitle': 'Check your email to confirm your address',
    'signup.successBody':
      'We have sent a message to the address you gave. Open the link in it to confirm the address; your site is set up after that.',
    'signup.resend.title': 'Send the confirmation email again',
    'signup.resend.intro': 'Enter the email address you signed up with.',
    'signup.resend.submit': 'Send again',
    'signup.resend.submitting': 'Sending...',
    'signup.resend.done':
      "If this address has an account that hasn't been confirmed yet, we've sent a new confirmation link.",
    'signup.resend.link': "Didn't get the email? Send it again",
    'signup.resend.formPrompt':
      "Already signed up but didn't get the confirmation email?",
    'signup.resend.formLink': 'Send it again',
    'signup.backToLogin': 'Back to sign in',
    'signup.section.invite': 'Your invite',
    'signup.section.you': 'You',
    'signup.section.site': 'Your site',
    'signup.section.inviteHelp':
      'The code you were given decides that you may sign up.',
    'signup.section.youHelp':
      'Your own account; you sign in with this address and password.',
    'signup.section.siteHelp':
      'The name your visitors see; the address follows from it.',
    'signup.verify.confirmTitle': 'Confirm your email address',
    'signup.verify.confirmBody': 'One click and your account is ready.',
    'signup.verify.confirm': 'Confirm',
    'signup.verify.verifiedTitle': 'Your address is confirmed',
    'signup.verify.verifiedBody': 'Your account is ready. Sign in to continue.',
    'signup.verify.signIn': 'Sign in',
    'signup.verify.invalidTitle': 'The link is not valid',
    'signup.verify.invalidBody': 'This link has expired or was already used.',
    'signup.verify.newLink': 'Send a new link',
    'language.label': 'Language',
    'signup.inviteCodeHelp':
      'Signup is by invitation. You get an invite code from Codeware; ask the person who pointed you here, or write to us.',
    'signup.addressPreview': 'A custom domain can be connected later.',
    'signup.availability.checking': 'Checking…',
    'signup.availability.available': 'Available',
    'signup.error.invalid':
      'Some details are missing or not valid. Check the form and try again.',
    'signup.error.password':
      'The password must be between 12 and 128 characters.',
    'signup.error.password-breached':
      'This password has appeared in a data breach elsewhere. Choose another one.',
    'signup.error.deployment': 'This name cannot be used.',
    'signup.error.code': "This invite code can't be used.",
    'signup.error.closed': "Signup isn't open right now.",
    'signup.error.throttled': 'Too many attempts. Try again later.',
    'signup.error.email-taken':
      'There is already an account with this email address.',
    'signup.error.deployment-taken':
      'A site with a very similar name already exists. Try another name.',
    'signup.error.name-taken': 'That name is already taken. Try another.',
    'signup.error.failed': 'Something went wrong. Try again in a moment.',
    'signup.issue.empty': 'The name needs at least one letter or digit.',
    'signup.issue.characters': 'The name needs at least one letter or digit.',
    'signup.issue.hyphens': 'The name needs at least one letter or digit.',
    'signup.issue.reserved': 'This name is reserved. Try another.',
    'signup.issue.too-long': 'The name is too long. Try a shorter one.',
    'siteGate.heading': 'This site is not open',
    'siteGate.intro': 'Enter the password to continue.',
    'siteGate.password': 'Password',
    'siteGate.submit': 'Show the site',
    'siteGate.tooManyAttempts':
      'Too many attempts. Wait a moment, then try again.',
    'siteGate.wrongPassword': 'That password does not open this site.',
    'social.clickToCopy': 'Click to copy',
    'social.copied': 'Copied',
    'social.copyFailed': 'Failed to copy to clipboard',
    'theme.select': 'Select theme',
    'tours.addToCalendar': 'Add to calendar',
    'tours.backToTours': 'Go back to tours',
    'tours.bookBefore': 'Book before',
    'tours.badgeFull': 'Full',
    'tours.badgeQueue': 'Waiting list',
    'tours.datesToBeConfirmed': 'Dates to be confirmed',
    'tours.bookingLede':
      'Send us a request and we will confirm your place. Bookings close {{date}}.',
    'tours.bookTour': 'Book this tour',
    'tours.day': 'Day {{day}}',
    'tours.departure': 'Departure',
    'tours.duration': 'Duration',
    'tours.included': "What's included",
    'tours.itinerary': 'Itinerary',
    'tours.notIncluded': 'Not included',
    'tours.perPerson': 'per person',
    'tours.price': 'Price',
    'tours.interestLede':
      'Tell us you are interested and we will be in touch once the departure is confirmed. Nothing is binding.',
    'tours.print': 'Print this tour',
    'tourSignupEmail.bookedBody':
      'Your place on {{tour}} is confirmed. We will be in touch closer to departure with the practical details.',
    'tourSignupEmail.departureLabel': 'Departure',
    'tourSignupEmail.detailsHeading': 'Your signup',
    'tourSignupEmail.greeting': 'Hi {{name}},',
    'tourSignupEmail.notificationBody':
      '{{name}} signed up for {{tour}} for {{people}} people.',
    'tourSignupEmail.notificationHeading': 'New signup',
    'tourSignupEmail.peopleLabel': 'Travellers',
    'tourSignupEmail.privacyLink': 'How we handle your data',
    'tourSignupEmail.promotedBody':
      'A place has opened up on {{tour}} and it is yours. Your signup is now confirmed.',
    'tourSignupEmail.questions':
      'Just reply to this email if anything is unclear.',
    'tourSignupEmail.firstInQueueLabel': 'First in the waiting list',
    'tourSignupEmail.openTour': 'Open the tour',
    'tourSignupEmail.seatsFreeLabel': 'Places free',
    'tourSignupEmail.seatsFreedAction':
      'New signups join the waiting list rather than taking these places, so the tour only fills again when you move someone up.',
    'tourSignupEmail.seatsFreedBody':
      '{{count}} places are free on {{tour}}. {{name}} is first in the waiting list, for {{people}}.',
    'tourSignupEmail.subjectSeatsFreed': 'Places are free on {{tour}}',
    'tourSignupEmail.statusLabel': 'Status',
    'tourSignupEmail.statusBooked': 'Confirmed',
    'tourSignupEmail.statusWaiting': 'Waiting list',
    'tourSignupEmail.subjectBooked': 'Your place on {{tour}} is confirmed',
    'tourSignupEmail.subjectNotification': 'New signup for {{tour}}',
    'tourSignupEmail.subjectPromoted': 'A place has opened up on {{tour}}',
    'tourSignupEmail.subjectWaiting':
      'You are on the waiting list for {{tour}}',
    'tourSignupEmail.termsLink': 'Terms',
    'tourSignupEmail.tourLabel': 'Tour',
    'tourSignupEmail.waitingBody':
      '{{tour}} is fully booked, so you are on the waiting list. We will be in touch as soon as a place opens up — nothing is charged and you are free to change your mind.',
    'forgotPasswordEmail.body':
      'Someone asked to reset the password for your account at {{brand}}.',
    'forgotPasswordEmail.button': 'Choose a new password',
    'forgotPasswordEmail.greeting': 'Hi,',
    'forgotPasswordEmail.greetingNamed': 'Hi {{name}},',
    'forgotPasswordEmail.ignore':
      'If you did not ask for this, you can ignore this email. Your password stays unchanged.',
    'forgotPasswordEmail.subject': 'Reset your password',
    'statsAccountEmail.body':
      'Here is your login to the website statistics for {{brand}}.',
    'statsAccountEmail.button': 'Log in',
    'statsAccountEmail.changePassword':
      'Change the password under your profile in Umami once you have signed in.',
    'statsAccountEmail.heading': 'Your statistics login',
    'statsAccountEmail.passwordLabel': 'Password',
    'statsAccountEmail.subject': 'Your statistics login',
    'statsAccountEmail.usernameLabel': 'Username',
    'accountExists.subject': 'You already have an account',
    'accountExists.body':
      'Someone tried to create a new account with this email address. You already have an account, so you can sign in, or reset your password if you have forgotten it.',
    'accountExists.signIn': 'Sign in',
    'accountExists.reset': 'Reset your password',
    'accountExists.ignore': "If it wasn't you, you can ignore this email.",
    'verifyEmail.afterConfirm':
      'Once the address is confirmed, you can sign in and start building your new site.',
    'verifyEmail.body':
      'Welcome to {{brand}}! Confirm your email address to finish setting up your new site.',
    'verifyEmail.button': 'Confirm your email address',
    'verifyEmail.greeting': 'Hi,',
    'verifyEmail.greetingNamed': 'Hi {{name}},',
    'verifyEmail.ignore': 'If you did not sign up, you can ignore this email.',
    'verifyEmail.subject': 'Confirm your email address',
    'signupNotice.body': 'Someone signed up for a new workspace.',
    'signupNotice.button': 'Open the workspace in the admin',
    'signupNotice.deploymentLabel': 'Deployment',
    'signupNotice.detailsHeading': 'Signup',
    'signupNotice.emailLabel': 'Email',
    'signupNotice.nameLabel': 'Name',
    'signupNotice.nextStep': 'To take it live, run: {{command}}',
    'signupNotice.siteLabel': 'Site address',
    'signupNotice.subject': 'New self-serve signup: {{tenantName}}',
    'signupNotice.workspaceLabel': 'Workspace',
    'idleWorkspaceSummary.body':
      'The nightly cleanup of workspaces that never got a page found the following.',
    'idleWorkspaceSummary.button': 'Open the admin',
    'idleWorkspaceSummary.deleted': 'Deleted, with {{users}} user(s) removed',
    'idleWorkspaceSummary.detailsHeading': 'Workspaces',
    'idleWorkspaceSummary.provisioned':
      'Has provisioning traces; deprovision by hand',
    'idleWorkspaceSummary.subject': 'Idle workspace cleanup',
    'idleWorkspaceSummary.unwarnedMailFailed':
      'Could not warn: the warning mail failed; will retry tomorrow',
    'idleWorkspaceSummary.unwarnedNoAdmin':
      'Could not warn: no verified admin; handle by hand',
    'idleWorkspaceSummary.warned': 'Warned, deletes on {{date}}',
    'idleWorkspaceWarning.body':
      'Your workspace {{name}} has no pages yet. It will be deleted on {{date}} unless a page is added before then.',
    'idleWorkspaceWarning.button': 'Open the admin',
    'idleWorkspaceWarning.ignore':
      'If you no longer want the workspace, there is nothing you need to do.',
    'idleWorkspaceWarning.subject':
      'Your workspace {{name}} will be deleted on {{date}}',
    'tourSignup.acceptTerms': 'I accept the terms',
    'tourSignup.acceptTermsRequired': 'Please accept the terms to sign up',
    'tourSignup.dataNotice':
      'We store your name, email, phone number and party size to run this tour.',
    'tourSignup.dataNoticeRetention':
      'Your details are cleared {{days}} days after departure.',
    'tourSignup.privacyLink': 'How we handle your data',
    'tourSignup.termsLink': 'Read the terms',
    'tourSignup.email': 'Email',
    'tourSignup.failed': 'Your signup could not be sent. Please try again.',
    'tourSignup.full': 'This tour is full',
    'tourSignup.queueOnly': 'Places are offered from the waiting list',
    'tourSignup.queueOnlyCount':
      '{{count}} places left — offered to the waiting list first',
    'tourSignup.queueOnlyCountOne':
      '1 place left — offered to the waiting list first',
    'tourSignup.queueOnlyLede':
      'Others are already waiting for a place on this tour, so signups join the waiting list in turn. We will be in touch when it is your turn.',
    'tourSignup.fullLede':
      'Join the waiting list and we will be in touch if a place opens up.',
    'tourSignup.joinWaitingList': 'Join the waiting list',
    'tourSignup.name': 'Name',
    'tourSignup.people': 'Number of travellers',
    'tourSignup.peopleHelp': 'Including yourself.',
    'tourSignup.phone': 'Phone',
    'tourSignup.phoneOptional': 'Optional, but useful on the day of departure.',
    'tourSignup.required': 'Please fill in this field',
    'tourSignup.seatsLeft': '{{count}} places left',
    'tourSignup.seatsLeftOne': '1 place left',
    'tourSignup.signupsClosed': 'Signups for this tour are closed.',
    'tourSignup.submit': 'Send signup',
    'tourSignup.submitting': 'Sending…',
    'tourSignup.successBooked':
      'Thank you! Your signup is registered and we have sent you a confirmation.',
    'tourSignup.successWaiting':
      'Thank you! You are on the waiting list and we will be in touch if a place opens up.',
    'tourSignup.title': 'Sign up',
    'tourSignup.tooManyPeople': 'Please enter a number between 1 and {{max}}',
    'tours.registerInterest': 'Register interest',
    'tours.signUpBefore': 'Sign up before',
    'tours.share': 'Share this tour',
    'tours.shareCopied': 'Link copied to clipboard',
    'tours.shareFailed': 'Could not copy the link',
    'tours.viewItinerary': 'View full itinerary'
  },
  sv: {
    'about.built': 'Byggd',
    'about.commit': 'Commit',
    'about.environment': 'Miljö',
    'about.release': 'Utgåva',
    'about.version': 'Version',
    'colorScheme.currentClickFor':
      'Nuvarande: {{current}}, klicka för {{next}}',
    'colorScheme.dark': 'mörkt',
    'colorScheme.light': 'ljust',
    'colorScheme.select': 'Välj utseende',
    'colorScheme.switchTo': 'Byt till {{colorScheme}} utseende',
    'colorScheme.system': 'systeminställning',
    'error.contactAdmin': 'Kontakta administratören om problemet kvarstår.',
    'error.landingPageNotFound': 'Startsida hittades inte',
    'error.landingPageNotFoundDescription':
      'Skapa en sida i CMS och tilldela den som startsida.',
    'error.landingPageRenderFailed': 'Startsidan kunde inte visas.',
    'error.pageRenderFailed': 'Sidan du söker kunde inte visas.',
    'error.somethingWentWrong': 'Något gick fel!',
    'error.unableToLoadContent':
      'Det gick inte att ladda innehållet. Försök igen senare.',
    'iconPicker.dialogDescription': 'Välj den mest lämpade ikonen',
    'iconPicker.dialogTitle': 'Välj en ikon',
    'iconPicker.noIconsFound': 'Inga ikoner hittades...',
    'iconPicker.searchClearButton': 'Rensa sökning',
    'iconPicker.searchFieldPlaceholder': 'Sök ikon...',
    'iconPicker.labelSelect': 'Välj ikon',
    'imageCrop.cancel': 'Avbryt',
    'imageCrop.chooseImage': 'Välj bild',
    'imageCrop.confirm': 'Bekräfta',
    'imageCrop.confirming': 'Laddar upp…',
    'imageCrop.cropError': 'Kunde inte bearbeta bilden. Försök igen.',
    'imageCrop.noFileChosen': 'Ingen fil vald',
    'imageCrop.zoom': 'Zoom',
    'image.loadFailed': 'Bilden kunde inte laddas.',
    'iconCrop.currentIconAlt': 'Aktuell ikon',
    'iconCrop.drawerTitle': 'Beskär ikon (1:1)',
    'iconCrop.mediaFallback': 'Media #{{id}}',
    'iconCrop.remove': 'Ta bort',
    'iconCrop.replace': 'Ersätt',
    'iconCrop.uploadAndCrop': 'Ladda upp och beskär',
    'iconCrop.uploadFailed': 'Uppladdning misslyckades',
    'iconCrop.uploadFailedStatus':
      'Uppladdning misslyckades ({{status}}): {{message}}',
    'svgPreview.browseStudio': 'Bläddra i studio',
    'fileArea.download': 'Ladda ner',
    'fileArea.noFiles': 'Inga filer',
    'fileArea.previewNotAvailable':
      'Förhandsgranskning ej tillgänglig för den här filtypen',
    'fileArea.search': 'Sök...',
    'fileArea.sort': 'Sortera',
    'fileArea.sortDateNewest': 'Nyast först',
    'fileArea.sortDateOldest': 'Äldst först',
    'fileArea.sortNameAsc': 'Namn (A-Ö)',
    'fileArea.sortNameDesc': 'Namn (Ö-A)',
    'fileArea.sortSizeLargest': 'Storlek (störst)',
    'fileArea.sortSizeSmallest': 'Storlek (minst)',
    'fileArea.typeAudio': 'Ljud',
    'fileArea.typeDocument': 'Dokument',
    'fileArea.typeImage': 'Bild',
    'fileArea.typeOther': 'Övrigt',
    'fileArea.typePdf': 'PDF',
    'fileArea.typePresentation': 'Presentation',
    'fileArea.typeSpreadsheet': 'Kalkylark',
    'fileArea.typeVideo': 'Video',
    'fileArea.viewGrid': 'Rutnätsvy',
    'fileArea.viewList': 'Listvy',
    'form.submitSuccess': 'Formuläret skickades in',
    'form.submitFailed': 'Formuläret kunde inte skickas in',
    'form.submitFailedDescription': 'Försök igen.',
    'humanCheck.unavailable':
      'Skräppostskyddet kunde inte laddas, så formuläret går inte att skicka. Orsaken är oftast en innehållsblockerare – tillåt challenges.cloudflare.com eller prova en annan webbläsare.',
    'gallery.accepts': 'Kan innehålla',
    'gallery.allBlocks': 'Alla block',
    'gallery.band': 'Bakgrund',
    'gallery.band.gradient': 'Färgtoning',
    'gallery.band.none': 'Ingen',
    'gallery.band.strong': 'Kraftig',
    'gallery.band.subtle': 'Diskret',
    'gallery.close': 'Stäng helskärm',
    'gallery.conditional': 'Visas beroende på ett annat val',
    'gallery.availableIn': 'Tillgängligt i',
    'gallery.fieldsNote':
      'Genereras från blockets definition, så tabellen kan inte glida ifrån de fält som administrationen faktiskt visar.',
    'gallery.nameInAdmin': 'Namn i administrationen',
    'gallery.live': 'Live',
    'gallery.liveNote':
      'Följer temat ovan — ingen CSS är skriven för den här sidan.',
    'gallery.example': 'Exempel',
    'gallery.fields': 'Vad en redaktör fyller i',
    'gallery.next': 'Nästa block',
    'gallery.notOffered':
      'Redaktörer kan inte lägga till det här blocket på en sida, men det visas fortfarande där det redan används.',
    'gallery.ownBuild':
      'Det som det här blocket visar bygger varje arbetsytas egna utvecklare, så det finns inget exempel att rita här. Se det där en sida använder ett.',
    'gallery.previous': 'Föregående block',
    'gallery.required': 'obligatoriskt',
    'gallery.expand': 'Helskärm',
    'gallery.localized': 'Översätts per språk',
    'gallery.whenToUse': 'När det passar',
    'gallery.contentBlocks': 'Innehållsblock',
    'gallery.documented': 'Beskrivna',
    'gallery.pending': 'Inte med i rutnätet ovan',
    'gallery.pendingNote':
      'Ett block dyker upp här samma dag det byggs — antingen har ingen skrivit om det ännu, eller så erbjuds det inte när en sida sätts ihop. Listan läses från koden själv, så galleriet kan inte i tysthet halka efter vad plattformen kan.',
    'gallery.registered': 'Registrerade',
    'gallery.structural': 'Strukturella',
    'gallery.structuralNote':
      'Listade för fullständighetens skull, inte ett designval en redaktör gör.',
    'gallery.undocumented': 'Ingen har skrivit om det här ännu.',
    'navigation.close': 'Stäng menyn',
    'navigation.footer': 'Sidfot',
    'navigation.menu': 'Meny',
    'memberLogin.code': 'Kod',
    'memberLogin.codeFailed':
      'Koden fungerade inte. Ange den aktuella koden från din autentiseringsapp.',
    'memberLogin.codeIntro':
      'Ange den sexsiffriga koden från din autentiseringsapp.',
    'memberLogin.codeSubmit': 'Fortsätt',
    'memberLogin.email': 'E-post',
    'memberLogin.failed':
      'Kontrollera e-postadressen och lösenordet och försök igen.',
    'memberLogin.heading': 'Logga in',
    'memberLogin.intro':
      'Logga in för att läsa de delar av webbplatsen som är till för medlemmar.',
    'memberLogin.password': 'Lösenord',
    'memberLogin.setupRequired':
      'Ditt konto behöver en autentiseringsapp. Lägg till den i administrationen och logga sedan in här.',
    'memberLogin.signOut': 'Logga ut',
    'memberLogin.submit': 'Logga in',
    'memberLogin.tooManyAttempts':
      'För många försök. Vänta en stund och försök igen.',
    'navigation.primary': 'Huvudmeny',
    'navigation.title': 'Navigation',
    'notFound.description': 'Tyvärr kunde vi inte hitta sidan du letade efter.',
    'notFound.goHome': 'Gå tillbaka till startsidan',
    'notFound.title': 'Sidan hittades inte',
    'posts.readMore': 'Läs mer',
    'signup.title': 'Skapa din webbplats',
    'signup.intro': 'Fyll i uppgifterna nedan för att få din egen webbplats.',
    'signup.closed':
      'Registreringen är inte öppen just nu. Titta in igen senare.',
    'signup.code': 'Inbjudningskod',
    'signup.name': 'Ditt namn',
    'signup.email': 'E-postadress',
    'signup.password': 'Lösenord',
    'signup.passwordHint': 'Minst 12 tecken.',
    'signup.siteName': 'Webbplatsens namn',
    'signup.submit': 'Skapa webbplats',
    'signup.submitting': 'Skapar webbplatsen...',
    'signup.successTitle': 'Kolla din e-post för att bekräfta adressen',
    'signup.successBody':
      'Vi har skickat ett meddelande till e-postadressen du angav. Öppna länken i meddelandet för att bekräfta adressen, så görs webbplatsen i ordning därefter.',
    'signup.resend.title': 'Skicka bekräftelsemejlet igen',
    'signup.resend.intro': 'Ange e-postadressen du registrerade dig med.',
    'signup.resend.submit': 'Skicka igen',
    'signup.resend.submitting': 'Skickar...',
    'signup.resend.done':
      'Om adressen har ett konto som ännu inte är bekräftat har vi skickat en ny bekräftelselänk.',
    'signup.resend.link': 'Fick du inget mejl? Skicka det igen',
    'signup.resend.formPrompt':
      'Har du redan registrerat dig men inte fått bekräftelsemejlet?',
    'signup.resend.formLink': 'Skicka det igen',
    'signup.backToLogin': 'Tillbaka till inloggningen',
    'signup.section.invite': 'Din inbjudan',
    'signup.section.you': 'Du',
    'signup.section.site': 'Din webbplats',
    'signup.section.inviteHelp':
      'Koden du har fått avgör att du får registrera dig.',
    'signup.section.youHelp':
      'Ditt eget konto. Du loggar in med den här adressen och det här lösenordet.',
    'signup.section.siteHelp':
      'Namnet som dina besökare ser. Adressen följer av namnet.',
    'signup.verify.confirmTitle': 'Bekräfta din e-postadress',
    'signup.verify.confirmBody': 'Ett klick så är kontot klart.',
    'signup.verify.confirm': 'Bekräfta',
    'signup.verify.verifiedTitle': 'Din e-postadress är bekräftad',
    'signup.verify.verifiedBody':
      'Ditt konto är klart. Logga in för att fortsätta.',
    'signup.verify.signIn': 'Logga in',
    'signup.verify.invalidTitle': 'Länken fungerar inte',
    'signup.verify.invalidBody':
      'Länken har slutat gälla eller har redan använts.',
    'signup.verify.newLink': 'Skicka en ny länk',
    'language.label': 'Språk',
    'signup.inviteCodeHelp':
      'Registreringen sker via inbjudan. Inbjudningskoden får du av Codeware. Fråga den som hänvisade dig hit, eller skriv till oss.',
    'signup.addressPreview':
      'En egen domän kan kopplas till webbplatsen senare.',
    'signup.availability.checking': 'Kontrollerar…',
    'signup.availability.available': 'Ledig',
    'signup.error.invalid':
      'Några uppgifter saknas eller är ogiltiga. Kontrollera formuläret och försök igen.',
    'signup.error.password': 'Lösenordet måste vara mellan 12 och 128 tecken.',
    'signup.error.password-breached':
      'Lösenordet finns med i en dataläcka någon annanstans. Välj ett annat lösenord.',
    'signup.error.deployment': 'Det här namnet kan inte användas.',
    'signup.error.code': 'Den här inbjudningskoden kan inte användas.',
    'signup.error.closed': 'Registreringen är inte öppen just nu.',
    'signup.error.throttled': 'För många försök. Försök igen senare.',
    'signup.error.email-taken':
      'Det finns redan ett konto med den här e-postadressen.',
    'signup.error.deployment-taken':
      'Det finns redan en webbplats med ett mycket liknande namn. Prova ett annat namn.',
    'signup.error.name-taken': 'Namnet är redan upptaget. Prova ett annat.',
    'signup.error.failed': 'Något gick fel. Försök igen om en stund.',
    'signup.issue.empty':
      'Namnet måste innehålla minst en bokstav eller siffra.',
    'signup.issue.characters':
      'Namnet måste innehålla minst en bokstav eller siffra.',
    'signup.issue.hyphens':
      'Namnet måste innehålla minst en bokstav eller siffra.',
    'signup.issue.reserved': 'Det här namnet är reserverat. Prova ett annat.',
    'signup.issue.too-long': 'Namnet är för långt. Prova ett kortare.',
    'siteGate.heading': 'Webbplatsen är inte öppen',
    'siteGate.intro': 'Ange lösenordet för att fortsätta.',
    'siteGate.password': 'Lösenord',
    'siteGate.submit': 'Visa webbplatsen',
    'siteGate.tooManyAttempts':
      'För många försök. Vänta en stund och försök sedan igen.',
    'siteGate.wrongPassword': 'Lösenordet öppnar inte den här webbplatsen.',
    'social.clickToCopy': 'Klicka för att kopiera',
    'social.copied': 'Kopierad',
    'social.copyFailed': 'Kopiering misslyckades',
    'theme.select': 'Välj tema',
    'tours.addToCalendar': 'Lägg till i kalendern',
    'tours.backToTours': 'Tillbaka till resor',
    'tours.bookBefore': 'Boka senast',
    'tours.badgeFull': 'Fullbokad',
    'tours.badgeQueue': 'Väntelista',
    'tours.datesToBeConfirmed': 'Datum ej fastställt',
    'tours.bookingLede':
      'Skicka en förfrågan så bekräftar vi din plats. Bokningen stänger {{date}}.',
    'tours.bookTour': 'Boka den här resan',
    'tours.day': 'Dag {{day}}',
    'tours.departure': 'Avresa',
    'tours.duration': 'Längd',
    'tours.included': 'Det här ingår',
    'tours.itinerary': 'Resplan',
    'tours.notIncluded': 'Ingår inte',
    'tours.perPerson': 'per person',
    'tours.price': 'Pris',
    'tours.interestLede':
      'Meddela att du är intresserad så hör vi av oss när avresan är bekräftad. Ingenting är bindande.',
    'tours.print': 'Skriv ut resan',
    'tourSignupEmail.bookedBody':
      'Din plats på {{tour}} är bekräftad. Vi hör av oss närmare avresan med praktiska detaljer.',
    'tourSignupEmail.departureLabel': 'Avresa',
    'tourSignupEmail.detailsHeading': 'Din anmälan',
    'tourSignupEmail.greeting': 'Hej {{name}},',
    'tourSignupEmail.notificationBody':
      '{{name}} har anmält sig till {{tour}} för {{people}} personer.',
    'tourSignupEmail.notificationHeading': 'Ny anmälan',
    'tourSignupEmail.peopleLabel': 'Resenärer',
    'tourSignupEmail.privacyLink': 'Så hanterar vi dina uppgifter',
    'tourSignupEmail.promotedBody':
      'En plats har blivit ledig på {{tour}} och den är din. Din anmälan är nu bekräftad.',
    'tourSignupEmail.questions': 'Svara på det här mejlet om något är oklart.',
    'tourSignupEmail.firstInQueueLabel': 'Först i kön',
    'tourSignupEmail.openTour': 'Öppna resan',
    'tourSignupEmail.seatsFreeLabel': 'Lediga platser',
    'tourSignupEmail.seatsFreedAction':
      'Nya anmälningar hamnar i kön istället för att ta platserna, så resan fylls igen först när du flyttar upp någon.',
    'tourSignupEmail.seatsFreedBody':
      '{{count}} platser är lediga på {{tour}}. {{name}} står först i kön, för {{people}} personer.',
    'tourSignupEmail.subjectSeatsFreed': 'Lediga platser på {{tour}}',
    'tourSignupEmail.statusLabel': 'Status',
    'tourSignupEmail.statusBooked': 'Bekräftad',
    'tourSignupEmail.statusWaiting': 'Väntelista',
    'tourSignupEmail.subjectBooked': 'Din plats på {{tour}} är bekräftad',
    'tourSignupEmail.subjectNotification': 'Ny anmälan till {{tour}}',
    'tourSignupEmail.subjectPromoted': 'En plats har blivit ledig på {{tour}}',
    'tourSignupEmail.subjectWaiting': 'Du står i kön till {{tour}}',
    'tourSignupEmail.termsLink': 'Villkor',
    'tourSignupEmail.tourLabel': 'Resa',
    'tourSignupEmail.waitingBody':
      '{{tour}} är fullbokad, så du står i kön. Vi hör av oss så snart en plats blir ledig — inget debiteras och du kan ändra dig när du vill.',
    'forgotPasswordEmail.body':
      'Någon har bett om att återställa lösenordet för ditt konto hos {{brand}}.',
    'forgotPasswordEmail.button': 'Välj ett nytt lösenord',
    'forgotPasswordEmail.greeting': 'Hej,',
    'forgotPasswordEmail.greetingNamed': 'Hej {{name}},',
    'forgotPasswordEmail.ignore':
      'Om det inte var du kan du bortse från det här mejlet. Ditt lösenord ändras inte.',
    'forgotPasswordEmail.subject': 'Återställ ditt lösenord',
    'statsAccountEmail.body':
      'Här är din inloggning till webbplatsstatistiken för {{brand}}.',
    'statsAccountEmail.button': 'Logga in',
    'statsAccountEmail.changePassword':
      'Byt lösenord under din profil i Umami när du har loggat in.',
    'statsAccountEmail.heading': 'Din inloggning till statistiken',
    'statsAccountEmail.passwordLabel': 'Lösenord',
    'statsAccountEmail.subject': 'Din inloggning till statistiken',
    'statsAccountEmail.usernameLabel': 'Användarnamn',
    'accountExists.subject': 'Du har redan ett konto',
    'accountExists.body':
      'Någon försökte skapa ett nytt konto med den här e-postadressen. Du har redan ett konto, så du kan logga in eller återställa lösenordet om du har glömt det.',
    'accountExists.signIn': 'Logga in',
    'accountExists.reset': 'Återställ lösenordet',
    'accountExists.ignore':
      'Om det inte var du kan du bortse från det här mejlet.',
    'verifyEmail.afterConfirm':
      'När e-postadressen är bekräftad kan du logga in och börja bygga din nya webbplats.',
    'verifyEmail.body':
      'Välkommen till {{brand}}! Bekräfta din e-postadress för att slutföra uppsättningen av din nya webbplats.',
    'verifyEmail.button': 'Bekräfta din e-postadress',
    'verifyEmail.greeting': 'Hej,',
    'verifyEmail.greetingNamed': 'Hej {{name}},',
    'verifyEmail.ignore':
      'Om du inte har registrerat dig kan du bortse från det här mejlet.',
    'verifyEmail.subject': 'Bekräfta din e-postadress',
    'signupNotice.body': 'Någon har registrerat en ny arbetsyta.',
    'signupNotice.button': 'Öppna arbetsytan i admin',
    'signupNotice.deploymentLabel': 'Driftsättning',
    'signupNotice.detailsHeading': 'Registrering',
    'signupNotice.emailLabel': 'E-post',
    'signupNotice.nameLabel': 'Namn',
    'signupNotice.nextStep': 'Kör detta för att sätta den i drift: {{command}}',
    'signupNotice.siteLabel': 'Webbplatsadress',
    'signupNotice.subject': 'Ny självregistrering: {{tenantName}}',
    'signupNotice.workspaceLabel': 'Arbetsyta',
    'idleWorkspaceSummary.body':
      'Den nattliga städningen av arbetsytor som aldrig fick någon sida hittade följande.',
    'idleWorkspaceSummary.button': 'Öppna administrationen',
    'idleWorkspaceSummary.deleted':
      'Borttagen, med {{users}} användare borttagna',
    'idleWorkspaceSummary.detailsHeading': 'Arbetsytor',
    'idleWorkspaceSummary.provisioned':
      'Har spår av driftsättning; avetablera för hand',
    'idleWorkspaceSummary.subject': 'Städning av overksamma arbetsytor',
    'idleWorkspaceSummary.unwarnedMailFailed':
      'Kunde inte varnas: varningsmejlet misslyckades; försöker igen i morgon',
    'idleWorkspaceSummary.unwarnedNoAdmin':
      'Kunde inte varnas: ingen verifierad administratör; hantera för hand',
    'idleWorkspaceSummary.warned': 'Varnad, tas bort den {{date}}',
    'idleWorkspaceWarning.body':
      'Din arbetsyta {{name}} har inga sidor ännu. Arbetsytan tas bort den {{date}} om ingen sida har lagts till före dess.',
    'idleWorkspaceWarning.button': 'Öppna administrationen',
    'idleWorkspaceWarning.ignore':
      'Om du inte längre vill ha arbetsytan behöver du inte göra något.',
    'idleWorkspaceWarning.subject':
      'Din arbetsyta {{name}} tas bort den {{date}}',
    'tourSignup.acceptTerms': 'Jag godkänner villkoren',
    'tourSignup.acceptTermsRequired': 'Godkänn villkoren för att anmäla dig',
    'tourSignup.dataNotice':
      'Vi sparar ditt namn, din e-post, ditt telefonnummer och antal resenärer för att genomföra resan.',
    'tourSignup.dataNoticeRetention':
      'Dina uppgifter rensas {{days}} dagar efter avresan.',
    'tourSignup.privacyLink': 'Så hanterar vi dina uppgifter',
    'tourSignup.termsLink': 'Läs villkoren',
    'tourSignup.email': 'E-post',
    'tourSignup.failed': 'Anmälan kunde inte skickas. Försök igen.',
    'tourSignup.full': 'Resan är fullbokad',
    'tourSignup.queueOnly': 'Platser erbjuds från väntelistan',
    'tourSignup.queueOnlyCount':
      '{{count}} platser kvar — erbjuds först till väntelistan',
    'tourSignup.queueOnlyCountOne':
      '1 plats kvar — erbjuds först till väntelistan',
    'tourSignup.queueOnlyLede':
      'Andra väntar redan på plats på den här resan, så anmälningar ställs i kön i tur och ordning. Vi hör av oss när det är din tur.',
    'tourSignup.fullLede':
      'Ställ dig i kön så hör vi av oss om en plats blir ledig.',
    'tourSignup.joinWaitingList': 'Ställ mig i kön',
    'tourSignup.name': 'Namn',
    'tourSignup.people': 'Antal resenärer',
    'tourSignup.peopleHelp': 'Inklusive dig själv.',
    'tourSignup.phone': 'Telefon',
    'tourSignup.phoneOptional': 'Valfritt, men bra att ha på avresedagen.',
    'tourSignup.required': 'Fyll i det här fältet',
    'tourSignup.seatsLeft': '{{count}} platser kvar',
    'tourSignup.seatsLeftOne': '1 plats kvar',
    'tourSignup.signupsClosed': 'Anmälan till den här resan är stängd.',
    'tourSignup.submit': 'Skicka anmälan',
    'tourSignup.submitting': 'Skickar…',
    'tourSignup.successBooked':
      'Tack! Din anmälan är registrerad och vi har skickat en bekräftelse.',
    'tourSignup.successWaiting':
      'Tack! Du står i kön och vi hör av oss om en plats blir ledig.',
    'tourSignup.title': 'Anmäl dig',
    'tourSignup.tooManyPeople': 'Ange ett antal mellan 1 och {{max}}',
    'tours.registerInterest': 'Intresseanmälan',
    'tours.signUpBefore': 'Anmälan senast',
    'tours.share': 'Dela resan',
    'tours.shareCopied': 'Länken kopierad',
    'tours.shareFailed': 'Kunde inte kopiera länken',
    'tours.viewItinerary': 'Visa hela resplanen'
  }
} as const;

/**
 * Translate a key to the given locale.
 *
 * Falls back to English if the locale is not supported.
 * Supports simple `{{variable}}` interpolation via the `vars` argument.
 */
export function t(
  locale: string,
  key: TranslationKey,
  vars?: Record<string, string>
): string {
  const lang: SupportedLocale =
    locale in translations ? (locale as SupportedLocale) : 'en';

  let result: string = translations[lang][key] ?? translations.en[key] ?? key;

  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      result = result.replace(`{{${k}}}`, v);
    }
  }

  return result;
}
